<app-upload-form (newTabIndex)="tabIndex=$event"></app-upload-form>
<app-upload-list [tabIndex]="tabIndex"></app-upload-list>
